import { c as _c } from "react/compiler-runtime";
import { SellerUnitsAndProjectsOne } from "@/types/sup";
import { toSentenceCase } from "@/utils/string/to-sentence-case";
import Image from "next/image";
interface InteriorsProps {
  supOne: SellerUnitsAndProjectsOne;
}
export function Interiors(t0) {
  const $ = _c(6);
  const {
    supOne
  } = t0;
  let t1;
  if ($[0] !== supOne.spaceSummary?.interiors) {
    t1 = supOne.spaceSummary?.interiors || [];
    $[0] = supOne.spaceSummary?.interiors;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const interiors = t1;
  if (!interiors.length) {
    return null;
  }
  let t2;
  if ($[2] !== interiors) {
    t2 = interiors.map(_temp);
    $[2] = interiors;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div><div className="grid grid-cols-2 @4xl:grid-cols-4 gap-4">{t2}</div></div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(item, index) {
  const spaces = item.space || [];
  const spacesText = spaces.map(toSentenceCase).join(", ");
  return <div key={`interior-${index}`} className="flex flex-col items-center text-center"><div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center mb-2"><Image src="/images/furnishings/interior-design.svg" alt={item.name} width={24} height={24} className="text-gray-600" unoptimized={true} /></div><div className="text-xs font-medium text-gray-900 truncate w-full" title={item.name}>{item.name}</div>{spaces.length > 0 && <div className="text-xs text-gray-500 truncate w-full" title={spacesText}>({spacesText})</div>}</div>;
}